import React, { useEffect, useState } from 'react';
import MuiDialog from '@mui/material/Dialog';
import './tivigoDialog.css';

export const MODAL_OPENING_DURATION = 300;

const withSpringPaperClass = (paperSlot, open) => {
  const mergeClassName = (paperProps = {}) => ({
    ...paperProps,
    className: [
      paperProps.className,
      'tvup-ios-spring-paper',
      open ? 'is-tvup-spring-opening' : '',
    ].filter(Boolean).join(' '),
  });

  return typeof paperSlot === 'function'
    ? (ownerState) => mergeClassName(paperSlot(ownerState))
    : mergeClassName(paperSlot);
};

export function ModalOpeningLoader({ duration = MODAL_OPENING_DURATION }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(false), duration);
    return () => window.clearTimeout(timer);
  }, [duration]);

  if (!visible) return null;

  return (
    <div className="tvup-modal-opening-loader" role="status" aria-label="İçerik yükleniyor">
      <span aria-hidden="true" />
    </div>
  );
}

function TivigoDialog({ open, children, slotProps = {}, ...props }) {
  const mergedSlotProps = {
    ...slotProps,
    paper: withSpringPaperClass(slotProps.paper, open),
  };

  return (
    <MuiDialog {...props} open={open} slotProps={mergedSlotProps}>
      {children}
      {open ? <ModalOpeningLoader /> : null}
    </MuiDialog>
  );
}

export default TivigoDialog;
